import { Pessoa } from './pessoa.model';

export class WebContratoSeguro {
    idSeqSeguro: number;
    idPlano: number;
    idStatus: number;
    idContrato: number;
    idProcesso:number;
    pessoa: Pessoa;
    dtPreenchimento: Date;
    dtStatus: Date;
    nrProtocolo: string;
    ctbPensao: number;
    ctbInvalidez: number;
    nrPremioPensao: number;
    nrPremioInvalidez:number;
}